
import {
    FETCH_WARNING,
    FETCH_DUE
} from '../actions/types';


export const warningReducer = (state = {}, action) => {
    if (action.type === FETCH_WARNING) {
        return action.payload;
    }

    return state;
};

export const dueReducer = (state = {}, action) => {
    if (action.type === FETCH_DUE) {
        return action.payload;
    }

    return state;
};


